import { render, staticRenderFns, recyclableRender, components } from "./u-gap.vue?vue&type=template&id=f69acc36&scoped=true&"
var renderjs
import script from "./u-gap.vue?vue&type=script&lang=js&"
export * from "./u-gap.vue?vue&type=script&lang=js&"
import style0 from "./u-gap.vue?vue&type=style&index=0&id=f69acc36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69acc36",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-gap/u-gap.vue"
export default component.exports